import { Action, getModule, Module, VuexModule, Mutation } from 'vuex-module-decorators';
import store from '@/store/index';
import { WS_URL as ApiUrl } from '@/config';
import axios from 'axios';
import { ActiveEntitiesQuery, ActiveEntitiesSummary, DashboardClient, UserStatistic } from '@/apiclient/apiclient_generated';

@Module({ dynamic: true, namespaced: true, store, name: 'dashboard' })
export class DashboardModule extends VuexModule {
  private client = new DashboardClient(ApiUrl, axios);

  activeEntities = {} as ActiveEntitiesSummary;
  latestCreatedAccounts = [];
  latestActivations = [];
  latestValidations = [];
  expiringLicenses = [];

  customerStatistics = {
    licensesStatistic: [],
    licenseActivationsStatistic: []
  } as UserStatistic;

  @Action
  async getCustomerStatistic(userId) {
    const userStatistic = await this.client.getAccountStatistic(userId);

    this.setCustomerStatistic(userStatistic);
  }

  @Action
  async getLatestCreatedAccounts() {
    const accounts = await this.client.getLatestCreatedAccounts();

    this.setLatestCreatedAccounts(accounts);
  }

  @Action
  async getExpiringLicenses() {
    const licenses = await this.client.getExpiringLicenses();

    this.setExpiringLicenses(licenses);
  }

  @Action
  async getLatestActivations() {
    const activations = await this.client.getLatestActivations();

    this.setLatestActivations(activations);
  }

  @Action
  async getLatestValidations() {
    const validations = await this.client.getLatestValidations();

    this.setLatestValidations(validations);
  }

  @Action
  async getActiveEntities(query: ActiveEntitiesQuery) {
    const entities = await this.client.getActiveEntities(query);

    this.setActiveEntities(entities);
  }

  @Mutation
  setLatestCreatedAccounts(accounts) {
    accounts.forEach((acc) => {
      if (acc.createdDate) {
        acc.createdDate = new Date(acc.createdDate);
      }

      if (acc.modifiedDate) {
        acc.modifiedDate = new Date(acc.modifiedDate);
      }
    });

    this.latestCreatedAccounts = accounts;
  }

  @Mutation
  setExpiringLicenses(licenses) {
    this.expiringLicenses = licenses;
  }

  @Mutation
  setActiveEntities(accounts) {
    this.activeEntities = accounts;
  }

  @Mutation
  setLatestActivations(activations) {
    activations.forEach((a) => {
      if (a.createTime) {
        a.createTime = new Date(a.createTime);
      }

      if (a.modifiedDate) {
        a.modifiedDate = new Date(a.modifiedDate);
      }
    });

    this.latestActivations = activations;
  }

  @Mutation
  setLatestValidations(validations) {
    validations.forEach((a) => {
      if (a.createTime) {
        a.createTime = new Date(a.createTime);
      }

      if (a.modifiedDate) {
        a.modifiedDate = new Date(a.modifiedDate);
      }
    });

    this.latestValidations = validations;
  }

  @Mutation
  setCustomerStatistic(statistic) {
    this.customerStatistics = statistic;
  }
}

export const DashboardStore = getModule(DashboardModule);
